import checkCanTranslate from '../utils/checkCanTranslate';
import ConversationItemParts from 'owa-mail-store/lib/store/schema/ConversationItemParts';
import getLocalePropertyForItem from '../services/getLocalePropertyForItem';
import initSupportedLanguages from '../utils/initSupportedLanguages';
import store from '../store/store';
import { action } from 'satcheljs/lib/legacy';
import { ClientItem, mailStore } from 'owa-mail-store';

export default action('setItemLocale')(async function setItemLocale(item: ClientItem) {
    // Load supported languages and check if user locale has changed since last time.
    const localeChanged =
        (await initSupportedLanguages()) ||
        store.userLanguageName != item.TranslationData.userLanguage;

    if (localeChanged) {
        const conversationItemParts: ConversationItemParts = mailStore.conversations.get(
            item.ConversationId.Id
        );

        item.TranslationData.userLanguage = store.userLanguageName;
        // If user locale is not supported, return
        if (!store.isUserLocaleSupported) {
            // but, update isTranslatable before leaving
            item.TranslationData.isTranslatable = false;
            item.TranslationData.isShowingTranslation = false;
            item.TranslationData.translationText = null;
            conversationItemParts.subjectTranslationData.isShowingTranslation = false;
            conversationItemParts.subjectTranslationData.translationText = null;
            return;
        }

        let locale = item.TranslationData.itemLocale;
        if (locale == null) {
            locale = await getLocalePropertyForItem(item);
            item.TranslationData.itemLocale = locale;
        }

        const isTranslatable = checkCanTranslate(store.localeOfSupportedLanguageMap, locale);
        item.TranslationData.isTranslatable = isTranslatable;
        if (!isTranslatable || localeChanged) {
            item.TranslationData.isShowingTranslation = false;
            item.TranslationData.translationText = null;
            conversationItemParts.subjectTranslationData.isShowingTranslation = false;
            conversationItemParts.subjectTranslationData.translationText = null;
        }
    }
});
